import { computed, Ref, ref } from "@vue/composition-api";

export const UseLocalSearch = (
  min_chars: number
): [Ref<string>, Readonly<Ref<Readonly<boolean>>>] => {
  const query = ref("");
  const is_searching = computed(() => query.value.length > min_chars);
  return [query, is_searching];
};

export const UseFiniteCollectionSearch = <T>(
  min_chars: number,
  query_fn: (o: T, query: string) => boolean,
  seed: T[]
): [
  Ref<string>,
  Readonly<Ref<Readonly<boolean>>>,
  Readonly<Ref<readonly T[]>>,
  () => void,
  (items: T[]) => void
] => {
  const query = ref("");
  const _items: Ref<T[]> = ref(seed);
  const display_items = computed(() => {
    if (query.value.length > min_chars) {
      return _items.value.filter((f) => query_fn(f, query.value));
    } else {
      return [];
    }
  });
  const is_searching = computed(() => query.value.length > min_chars);
  const set_items = (items: T[]) => {
    _items.value = items;
  };
  const clear = () => {
    query.value = "";
  };

  return [query, is_searching, display_items, clear, set_items];
};
